import { Currency } from '@components/UIKit/Currency/Currency';
import { Dictionary, useTranslation } from '@hooks/useTranslation';
import React, { FC } from 'react';
import s from './toysSummary.module.scss';
import { ValueTypes } from '@specs/specs';
interface Props {
  amount: number;
  currency: ValueTypes;
  text: Dictionary;
}
export const PriceInCurrency: FC<Props> = ({
  currency,
  text,
  amount
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.summary__row} data-sentry-component="PriceInCurrency" data-sentry-source-file="PriceInCurrency.tsx">
            <div className={s.summary__currency}>
                {tr({
        id: text
      })}
            </div>
            <div className={s.summary__amount}>
                <Currency amount={amount} currency={currency} data-sentry-element="Currency" data-sentry-source-file="PriceInCurrency.tsx" />
            </div>
        </div>;
};